<div class="sidebar-container" 
     [class.collapsed]="!isExpanded()"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()">
    
    <!-- Header with Logo/Icon -->
    <div class="sidebar-header">
        <div class="sidebar-header-top">
            @if (isExpanded()) {
                <img src="/images/logo-kronoflow.webp" alt="KronoFlow" width="1000" height="259" class="sidebar-logo">
                <button mat-icon-button (click)="toggleSidebar()" class="toggle-btn"
                    [matTooltip]="isSidebarCollapsed() ? 'Fijar' : 'Colapsar'" [matTooltipPosition]="'right'">
                    <mat-icon>{{ isSidebarCollapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
                </button>
            } @else {
                <img src="/images/kronoflow-icon.webp" alt="KronoFlow" width="40" height="40" class="sidebar-icon">
            }
        </div>
        @if (isExpanded()) {
            <span class="sidebar-subtitle">Panel Administrativo</span>
        }
    </div>

    <!-- Navigation List -->
    <mat-nav-list class="sidebar-nav">
        @for (item of menuItems(); track item.label) {
            
            <!-- Items with children (collapsible) -->
            @if (item.children && item.children.length > 0) {
                <div class="nav-item-group" [class.is-expanded]="isMenuExpanded(item.label)">
                    <a mat-list-item (click)="toggleSubmenu(item.label, $event)"
                       class="nav-item has-children" [matTooltip]="!isExpanded() ? item.label : ''" [matTooltipPosition]="'right'">
                        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                        
                        @if (isExpanded()) {
                            <span matListItemTitle>{{ item.label }}</span>
                        }
                        
                        @if (isExpanded()) {
                            <mat-icon matListItemMeta class="expand-arrow">
                                {{ isMenuExpanded(item.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                            </mat-icon>
                        }
                    </a>
                    
                    @if (isExpanded() && isMenuExpanded(item.label)) {
                        <div class="submenu-container animate-fade-in">
                            @for (child of item.children; track child.label) {
                                <a mat-list-item [routerLink]="child.route" routerLinkActive="active-item"
                                   class="nav-item child-item">
                                    <mat-icon matListItemIcon class="mini-icon">{{ child.icon }}</mat-icon>
                                    <span matListItemTitle>{{ child.label }}</span>
                                </a>
                            }
                        </div>
                    }
                </div>
            } @else {
                <!-- Direct link items -->
                <a mat-list-item [routerLink]="item.route" routerLinkActive="active-item"
                    class="nav-item" [matTooltip]="!isExpanded() ? item.label : ''" [matTooltipPosition]="'right'">
                    <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                    @if (isExpanded()) {
                        <span matListItemTitle>{{ item.label }}</span>
                    }
                </a>
            }
        }
    </mat-nav-list>

    <!-- Footer with Version -->
    @if (isExpanded()) {
    <div class="sidebar-footer">
        <div class="footer-content">
            <span class="version-badge">v1.0.0</span>
        </div>
    </div>
    }
</div>